import { render, staticRenderFns } from "./ProductMore.vue?vue&type=template&id=ccc78a2c&scoped=true&"
import script from "./ProductMore.vue?vue&type=script&lang=js&"
export * from "./ProductMore.vue?vue&type=script&lang=js&"
import style0 from "./ProductMore.vue?vue&type=style&index=0&id=ccc78a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc78a2c",
  null
  
)

export default component.exports